import React from 'react';
import styles from './Disclosure.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

/**
 * The app's disclosure chevron: 18px, muted, rotating 180° when open.
 *
 * Lives in its own file because it is used OUTSIDE `Disclosure` too — the
 * group editor's child rows are expandable but are not disclosures (the row
 * is also the selection control, and selecting is what expands it). They
 * still have to look like every other expandable thing in the app, and the
 * text glyphs they used before did not.
 */
export const ChevronIcon = ({ open }) => (
  <svg
    className={clsx(styles.chevron, open && styles.chevronOpen)}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export default ChevronIcon;
